'use strict';

var getFindDeep = require('./getFindDeep.js');

function getFindValueDeep(_) {
  var findDeep = getFindDeep(_);
  function findValueDeep(obj, predicate, options) {
    var res = findDeep(obj, predicate, options);
    return res && res.value;
  }
  return findValueDeep;
}

module.exports = getFindValueDeep;



//////////////////
// WEBPACK FOOTER
// ./node_modules/deepdash/getFindValueDeep.js
// module id = ZaY8
// module chunks = 0